<template>
	<div>
		<div >
			<div class="">
				 <a-tabs v-model:activeKey="activeKey" @change="changeTab">
				    <a-tab-pane key="1" :tab="$t('studentsCom.myTeacher')">
						<div class="bg-w br12 py-3 px-4 d-flex justify-content-between alcenter mt-3" v-for="(item,index) in list">
							<div class="flex" style="flex:1;">
								<img :src="item.photo_image" alt="" class="photo-40" />
								<div class="ml15" style="width: 100%;">
									<div class="text-underline clickAct">
										{{item.name}} {{item.surname}}
									</div>
									<div class="ft14 cl-theme mt-2 over-hide" style="width: 80%;"> 
										{{item.synopsis}}
									</div>
								</div>
							</div>
							<div class="flex alcenter" >
								<img src="../../../assets/image/staduents/report-message.png" alt="" class="myTeacher-photo-40" 
								:title="$t('studentsCom.chat')" @click="openKefu(item.user_id)"/>
								<img src="../../../assets/image/staduents/report-appointment.png" alt="" style="width: 35px;height: 35px;"
								:title="$t('studentsCom.reserve')" class=" ml10" @click="toTeacher(item.id)" />
								<img src="../../../assets/image/staduents/report-buy.png" alt="" class="myTeacher-photo-40 ml10" 
								:title="$t('studentsCom.purchaseCourse')" @click="toTeacherDetails(item.id)"/>
								<!-- <button type="button" class="btn btn-theme " style="height: 40px;" @click="toTeacher(item.id)">{{$t('studentsCom.reserve')}}</button>
								<button type="button" class="btn btn-theme ml10" style="height: 40px;" @click="openKefu(item.user_id)">{{$t('studentsCom.chat')}}</button> -->
							</div>
						</div>
					</a-tab-pane>
				    <a-tab-pane key="2" :tab="$t('studentsCom.collectedTeachers')" >
						<div class="bg-w br12 py-3 px-4 d-flex justify-content-between alcenter mt-3" v-for="(item,index) in list">
							<div class="flex" style="flex:1;">
								<img :src="item.photo_image" alt="" class="photo-40" />
								<div class="ml15" style="width: 100%;">
									<div class="text-underline clickAct">
										{{item.name}} {{item.surname}}
									</div>
									<div class="ft14 cl-theme mt-2 over-hide" style="width: 80%;"> 
										{{item.synopsis}}
									</div>
								</div>
							</div>
							<div class="flex alcenter" >
								<img src="../../../assets/image/staduents/report-message.png" alt="" class="myTeacher-photo-40"
								:title="$t('studentsCom.chat')" @click="openKefu(item.user_id)"/>
								<img src="../../../assets/image/staduents/report-appointment.png" alt="" style="width: 35px;height: 35px;"
								:title="$t('studentsCom.reserve')" class=" ml10" @click="toTeacher(item.id)" />
								<img src="../../../assets/image/staduents/report-buy.png" alt="" class="myTeacher-photo-40 ml10" 
								:title="$t('studentsCom.purchaseCourse')" @click="toTeacherDetails(item.id)"/>
								<!-- <button type="button" class="btn btn-theme " style="height: 40px;" @click="toTeacher(item.id)">{{$t('studentsCom.reserve')}}</button>
								<button type="button" class="btn btn-theme ml10" style="height: 40px;" @click="openKefu(item.user_id)">{{$t('studentsCom.chat')}}</button> -->
							</div>
						</div>
					</a-tab-pane>
				    <a-tab-pane key="3" :tab="$t('studentsCom.pastTeachers')">
						<div class="bg-w br12 py-3 px-4 d-flex justify-content-between alcenter mt-3" v-for="(item,index) in list">
							<div class="flex" style="flex:1;">
								<img :src="item.photo_image" alt="" class="photo-40" />
								<div class="ml15" style="width: 100%;">
									<div class="text-underline clickAct">
										{{item.name}} {{item.surname}}
									</div>
									<div class="ft14 cl-theme mt-2 over-hide" style="width: 80%;"> 
										{{item.synopsis}}
									</div>
								</div>
							</div>
							<div class="flex alcenter" >
								<img src="../../../assets/image/staduents/report-message.png" alt="" class="myTeacher-photo-40"
								:title="$t('studentsCom.chat')" @click="openKefu(item.user_id)"/>
								<img src="../../../assets/image/staduents/report-appointment.png" alt="" style="width: 35px;height: 35px;"
								:title="$t('studentsCom.reserve')" class=" ml10" @click="toTeacher(item.id)" />
								<img src="../../../assets/image/staduents/report-buy.png" alt="" class="myTeacher-photo-40 ml10" 
								:title="$t('studentsCom.purchaseCourse')" @click="toTeacherDetails(item.id)"/>
								<!-- <button type="button" class="btn btn-theme " style="height: 40px;" @click="toTeacher(item.id)">{{$t('studentsCom.reserve')}}</button>
								<button type="button" class="btn btn-theme ml10" style="height: 40px;" @click="openKefu(item.user_id)">{{$t('studentsCom.chat')}}</button> -->
							</div>
						</div>
					</a-tab-pane>
				  </a-tabs>
			</div>
			<div class="mt-3">
				<!-- 推薦的老師 -->
				{{$t('studentsCom.recommendedTeacher')}}
			</div>
			<div class="bg-w br12 py-3 px-4 d-flex justify-content-between alcenter mt-3" v-for="(item,index) in recommendList">
				<div class="flex" style="flex:1;">
					<img :src="item.photo_image" alt="" class="photo-40" />
					<div class="ml15" style="width: 100%;">
						<div class="text-underline clickAct">
							{{item.name}} {{item.surname}}
						</div>
						<div class="ft14 cl-theme mt-2 over-hide" style="width: 80%;"> 
							{{item.synopsis}}
						</div>
					</div>
				</div>
				<div class="flex alcenter" >
					<img src="../../../assets/image/staduents/report-message.png" alt="" class="myTeacher-photo-40" @click="openKefu(item.user_id)"/>
					<img src="../../../assets/image/staduents/report-appointment.png" alt="" style="width: 35px;height: 35px;"
					class=" ml10" @click="toTeacher(item.id)" />
					<img src="../../../assets/image/staduents/report-buy.png" alt="" class="myTeacher-photo-40 ml10" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default{
		data(){
			return{
				list:[],
				recommendList:[],
				activeKey:'1',
			}
		},
		created(){
			this.getTeacherList()
			this.getrecommendList()
		},
		methods:{
			toProgress(item){
				this.showProgress = true
				this.$router.push('/studentsProgressReport?item='+JSON.stringify(item))
			},
			changeTab(e){
				console.log(e);
				this.getTeacherList(e)
			},
			getTeacherList(e){
				this.$http.api('teachers/teacherList',{
					page:1,
					limit:1000,
					is_my:1,
					is_collect:e==2?1:0,
					is_before:e==3?1:0,
				}).then(res=>{
					this.list = res.list
				})
			},
			getrecommendList(){
				this.$http.api('teachers/teacherList',{
					page:1,
					limit:1000,
					andom_sort:1
				}).then(res=>{
					this.recommendList = res.list
				})
			},
			toTeacher(id){
				this.$http.api('user/coursePackage',{
					is_experience:2,
					teacher_id:id
				}).then(res=>{
					if(res.list.length!=0){
						this.$router.push('/appointment?id='+res.list[0].id)
					}else{
						this.$message.error("該老師暫時沒有可用的課堂包")
					}
					
				})
				
			},
			toTeacherDetails(id){
				this.$router.push('/teacher?id='+id)
			}
		}
	}
</script>

<style>
	.myTeacher-photo-40{
		width: 40px;
		height: 40px;
	}
</style>